import { useQuery } from '@tanstack/react-query';
import { hoursToMilliseconds } from 'date-fns';
import { CreateCyclePayload } from '../../types/cycles';
import queryClient from '../queryClient';
import useAppMeta from './useAppMeta';

const useBuyCycle = (): [
  CreateCyclePayload | undefined | null,
  (arg0: CreateCyclePayload | null, transactionType?: string) => void
] => {
  const [{ data: meta }] = useAppMeta();

  let key = [`${meta?.transactionType}-buy`];
  return [
    useQuery<CreateCyclePayload>({
      queryKey: key,
      meta: { persist: true },
      enabled: !!meta?.transactionType,
      staleTime: hoursToMilliseconds(1),
    }).data,
    (data?: CreateCyclePayload | null, transactionType?: string) => {
      if (!meta.transactionType && !transactionType) {
        return;
      }
      key = [`${meta?.transactionType ?? transactionType}-buy`];
      queryClient.setQueryData<CreateCyclePayload | undefined | null>(
        key,
        data
      );
    },
  ];
};

export default useBuyCycle;
